import { useOrdersQuery, UseOrdersQueryParams } from "../queries/useOrdersQuery";
import { IPagination } from "../../../interfaces/IPagination";
import { OrderInterface } from "../../../interfaces/orderInterface";

type Response = {
  orders: OrderInterface[];
  paginationData?: IPagination;
  isLoading: boolean;
  refetch: () => void;
};

export const useOrders = (opt: UseOrdersQueryParams): Response => {
  const { data, isLoading, refetch } = useOrdersQuery(opt);
  return {
    orders: data?.data?.orders || [],
    paginationData: data?.data?.pagination,
    isLoading,
    refetch,
  };
};
